import {
    PLAN_DELETE_PLAN_LNG_BEGIN,
    PLAN_DELETE_PLAN_LNG_SUCCESS,
    PLAN_DELETE_PLAN_LNG_FAILURE,
    PLAN_DELETE_PLAN_LNG_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function deletePlan_lng(id) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: PLAN_DELETE_PLAN_LNG_BEGIN,
      });
  
      // Return a promise so that you could control UI flow without states in the store.
      // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
      // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
      // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
      const promise = new Promise((resolve, reject) => {
          request({
            method:'DELETE',
            url:`/api/gc/batch/lng/${id}`,
          }).then( data => {
              dispatch({
                  type: PLAN_DELETE_PLAN_LNG_SUCCESS,
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: PLAN_DELETE_PLAN_LNG_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissDeletePlan_lngError() {
    return {
      type: PLAN_DELETE_PLAN_LNG_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PLAN_DELETE_PLAN_LNG_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          deletePlan_lngPending: true,
          deletePlan_lngError: null,
        };
  
      case PLAN_DELETE_PLAN_LNG_SUCCESS:
        // The request is success
        return {
          ...state,
          deletePlan_lngPending: false,
          deletePlan_lngError: null,
        };
  
      case PLAN_DELETE_PLAN_LNG_FAILURE:
        // The request is failed
        return {
          ...state,
          deletePlan_lngPending: false,
          deletePlan_lngError: action.data.error,
        };
  
      case PLAN_DELETE_PLAN_LNG_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          deletePlan_lngError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/plan/redux/deletePlan_lng.js